import * as React from 'react';
import { Link } from 'react-router-dom';
import DocumentTitle from '../../misc/components/DocumentTitle';
import { PFTSessionListTable }  from "../Shared/PFTSessionListTable";
import { Authorization } from '../../misc/components/Authorization';
import { HamburgerMenu } from '../../misc/components/HamburgerMenu';
import { PermissionEnum } from '../../misc/api/ApiPermissionEnum';
import { DlcoAnalysisSetTypeEnum } from '../../misc/api/ApiDlcoAnalysisSetType';
import { SessionTypes } from '../../misc/api/ApiSessionTypes';
import {
    Permission,
} from "../../misc/api/apiTypes";
import { DlcoSession, WebPortalClient, DlcoAnalysisSet, FvcSession } from 'webportalclient';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { ODataParams, Query } from '../../Components/Query';
import { useWebPortalApiClient } from '../../misc/api/WebPortalTokenClient';


export const DlcoSessionListScreen = ({ }): JSX.Element => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getDlcoSessions(undefined, filter, params.orderby, 'visit($select=id,name,subjectId;$expand=subject($select=id,number,siteId;$expand=site($select=id,number,studyId))),analysisSets($select=id,type,status,user),tests($select=id;$count=true)', params.top, params.skip, undefined, true);
    }

    const GetOverreadAnalysisSet = (session: DlcoSession): DlcoAnalysisSet => {
        return session.analysisSets.find(dAs => dAs.type === DlcoAnalysisSetTypeEnum.Overread);
    }

    const RenderHamburgerMenu = (session: DlcoSession, currentPermissions: Permission[], currentStudyId: string) => {
        const overreadAnalysisSet = session.analysisSets.find(a => a.type === DlcoAnalysisSetTypeEnum.Overread);

        return (
            <HamburgerMenu>
                {!!overreadAnalysisSet ? <Authorization permissionId={PermissionEnum.AccessSingleDlcoSession}
                    studyId={currentStudyId}
                    currentPermissions={currentPermissions}
                >
                    <li>
                        <Link to={`Dlco/Analysis/${overreadAnalysisSet.id}/view`}>View</Link>
                    </li>
                </Authorization> : null}
            </HamburgerMenu>
        );
    };

    return (
        <DocumentTitle title="DLco Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "occurred", condition: "desc" }]}>
                <PFTSessionListTable
                    header="DLco Sessions"
                    sessionType={SessionTypes.Dlco}
                    hamburgerMenu={(session: FvcSession | DlcoSession, currentPermissions: Permission[], currentStudyId: string) => {
                        return RenderHamburgerMenu(session, currentPermissions, currentStudyId);
                    }}
                />
            </Query>
        </DocumentTitle>
    );
};

export default DlcoSessionListScreen;
